import { HsvValue } from '@/store/creative/model-editor/index.type'

// 因为 cocos 里面的 hsv 的值是 0-1 ，-1-1 的值，所以需要转换
export function normalizeHsv(hsv: HsvValue): HsvValue {
  return [hsv[0] * 360, ((hsv[1] + 1) * 50) / 100, ((hsv[2] + 1) * 50) / 100]
}

export function normalizeRgba(
  rgba: [number, number, number, number],
): [number, number, number, number] {
  return [
    Math.round(rgba[0] * 255),
    Math.round(rgba[1] * 255),
    Math.round(rgba[2] * 255),
    rgba[3],
  ]
}

export function normalizeToCocosFormat(
  rgba: [number, number, number, number],
): [number, number, number, number] {
  const normalizedColorArray = rgba.map((value, index) => {
    if (index < 3) {
      return value / 255
    }
    return value
  })
  return normalizedColorArray
}

export function normalizeHsvToCocosFormat(hsv: HsvValue): HsvValue {
  const normalizedH = hsv[0] / 360
  const normalizedS = hsv[1] * 2 - 1
  const normalizedV = hsv[2] * 2 - 1

  return [normalizedH, normalizedS, normalizedV]
}
